import React from 'react';
export const LookingToContext = React.createContext(null);
